import styled from 'styled-components';
import { StockCardStyled } from '../StockCardStyled';

export const StockCardStyledAP = styled(StockCardStyled)``;
